import React, { FC } from "react";
import { useTranslation } from "react-i18next";

import { SimpleDialogFallback } from "../DialogComponents/DialogFallback/SimpleDialogFallback";
import { DIALOG_STYLE } from "./components/BulkCopy";

export const BulkCopy: FC = () => {
  const { t } = useTranslation("common");

  return <SimpleDialogFallback context={{ ...DIALOG_STYLE, title: `${t("actions.copy")}...` }} />;
};
